import styled from "styled-components";

export const Container = styled.div`
  /* height: 96vh; */
  min-height: 622px;
  padding: 143px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 90px;
  padding-bottom: 20px;
  /* padding-left: 8.4%; */

  .title-container {
    width: 350px;
    margin-bottom: 40px;
  }

  .blogs {
    display: grid;
    grid-template-columns: repeat(2, 372px);
    grid-column-gap: 10vw;
  }

  .preview-container {
    width: 100%;
    height: 100%;
  }

  @media (max-width: 1024px) {
    max-width: 100vw;
    height: fit-content;
    padding-top: 52px;
    align-items: center;
    justify-content: center;
    justify-items: center;
    padding-left: 6vw;

    .title-container {
      width: 100%;
      margin-bottom: 0px;
    }

    .blogs {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
      grid-column-gap: 40vw;
      justify-content: center;
    }

    .preview-container {
      margin-bottom: 72px;
    }
  }

  @media (max-width: 700px) {
    padding-left: 143px;
    .title-container {
      max-width: 450px;
      min-width: 320px;
    }
  }
`;
